import { useTranslation } from "react-i18next";
import { cn } from "@/zapi-frontend/shared/lib/utils";
import type { TSpelledParts } from "@/zapi-frontend/shared/lib/rqaSim/twin";
import { FigureTrigger } from "../MemoIsland/FigureRefs/FigureTrigger";

type TTwinBoxProps = {
  figureKey: string;
  label: string;
  value: TSpelledParts | undefined;
  size: "band" | "card";
  stale?: boolean;
  noReturn?: boolean;
  was?: string;
};

export function TwinBox({ figureKey, label, value, size, stale, noReturn, was }: TTwinBoxProps) {
  const { t } = useTranslation("projectHome");
  const isCard = size === "card";
  const footnote = noReturn
    ? t("rqaSim.noReturn")
    : stale
    ? t("rqaSim.held")
    : was
    ? t("rqaSim.wasValue", { value: was })
    : null;
  return (
    <div className={cn("flex min-w-0 flex-col gap-2", !isCard && "bg-card p-4")}>
      {!isCard && <span className="typo-label-sm line-clamp-2 text-muted-foreground">{label}</span>}
      <span
        className={cn(
          "whitespace-nowrap tabular-nums text-foreground",
          isCard ? "typo-h3" : "typo-h4",
          was && !stale && !noReturn && "text-primary-text"
        )}
      >
        {value === undefined ? (
          "—"
        ) : (
          <>
            <FigureTrigger figureKey={figureKey}>{value.figure}</FigureTrigger>
            {value.unit && <span className="typo-caption ml-1 text-muted-foreground">{value.unit}</span>}
          </>
        )}
      </span>
      {footnote && (
        <span className={cn("typo-caption", stale && !noReturn ? "text-innoveraRed-700" : "text-muted-foreground")}>
          {footnote}
        </span>
      )}
    </div>
  );
}
